//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import template from '@legacy-components/common/universal-image-actions/universal-image-actions-one-page-buttons.html';
import { GaApi } from 'app/initialization/ga/ga-api';

(() => {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsOnePageButtons', [() => {
    return {
      restrict: 'E',
      scope: {},
      template,
      controller: [
        '$scope',
        'TrackingService',
        'UniversalImageActionsService',
        'UniversalImageActionsView',
        (
          $scope,
          TrackingService: GaApi,
          UniversalImageActionsService,
          UniversalImageActionsView,
        ) => {
          const workflow = UniversalImageActionsService.getCurrentWorkflow();

          $scope.model = {};

          $scope.model.disableDoneButton = () => {
            return workflow.getCurrentState() !== UniversalImageActionsView.OnePage.name;
          };

          $scope.model.close = () => {
            $scope.$emit('uia:modal:close', {
              result: {
                actionCompleted: TrackingService.ACTION_ONE_PAGE,
              },
            });
          };
        }
      ],
    };
  }]);
})();
